import React, { useState } from 'react';
import { AddButton } from '@common/components';
import { TextArea } from '@common/components/textarea';
import { InfoTooltip } from '@common/components/info-tooltip';
import { Form, Checkbox, Row, Col } from 'antd';
import { Store } from 'antd/lib/form/interface';

export type NotesFormProps = {
  initWithFormOpen?: boolean;
  infoTooltipText?: string;
  noteSubmitLoading?: boolean;
  preventNewNotes?: boolean;
  notificationLabel?: string;
  onNoteSubmit: (answer: Store) => void;
};

export function NotesForm({
  initWithFormOpen,
  infoTooltipText,
  noteSubmitLoading = false,
  notificationLabel = 'Notify users',
  preventNewNotes,
  onNoteSubmit,
}: NotesFormProps) {
  const [form] = Form.useForm();
  const [isFormOpen, setIsFormOpen] = useState(
    initWithFormOpen && !preventNewNotes
  );
  const [isFormValid, setIsFormValid] = useState(false);

  return (
    <div className="wk-notes-form">
      {isFormOpen ? (
        <div>
          <Form
            layout="vertical"
            form={form}
            initialValues={{
              notifyUsers: true,
            }}
            onFinish={(result) => {
              onNoteSubmit(result);
              setIsFormOpen(false);
              setIsFormValid(false);
              form.resetFields();
            }}
          >
            <Row>
              <Col span={18}>
                <Form.Item
                  name="note"
                  label={
                    <>
                      Note
                      {infoTooltipText && (
                        <InfoTooltip
                          size="1x"
                          leftOffset={4}
                          title={infoTooltipText}
                        />
                      )}
                    </>
                  }
                >
                  <TextArea
                    autoFocus={initWithFormOpen}
                    data-testid="notes-form-textarea"
                    maxLength={1000}
                    onChange={(e) => setIsFormValid(!!e.target.value)}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Form.Item name="notifyUsers" valuePropName="checked">
              <Checkbox data-testid="notify-users">
                {notificationLabel}
              </Checkbox>
            </Form.Item>
            <AddButton
              dataTestId="submit-button"
              disabled={!isFormValid || preventNewNotes}
              onClick={form.submit}
              loading={noteSubmitLoading}
            >
              Add Note
            </AddButton>
          </Form>
        </div>
      ) : (
        <AddButton
          dataTestId="toggle-button"
          disabled={preventNewNotes}
          loading={noteSubmitLoading}
          onClick={() => setIsFormOpen(true)}
        >
          Add Note
        </AddButton>
      )}
    </div>
  );
}
